import React from 'react';

import { Avatar } from '../../../../../../components/Avatar';
import { Timestamp } from '../../../../../../components/Timestamp';
import getComponentClasses from '../../../../../../utils/app/getComponentClasses';
import { RecentChats_recentChats, RecentChats_viewer } from '../../__generated__/RecentChats';
import getLastReadAtForChatViewer from '../../lib/getLastReadAt';
import { getRecipient } from '../../lib/getParticipant';
import { getAvatarURL, getProfileURL } from './helpers/urlgen';

export interface OnsiteMessagesListItemProps {
    chat: RecentChats_recentChats;
    isActive: boolean;
    viewer: RecentChats_viewer;
    variations?: string[];
    avatarVariations?: string[];
}

const getUnreadState = (eventCreatedAt: string, viewerLastReadAt: string | null) => {
    if (!viewerLastReadAt) return false;

    return eventCreatedAt > viewerLastReadAt;
};

export const OnsiteMessagesListItem = ({
    viewer,
    chat,
    isActive,
    variations = [],
    avatarVariations = ['small'],
}: OnsiteMessagesListItemProps) => {
    if (!chat.lastEvent) return null;
    const recipient = getRecipient(chat.participants, viewer);
    const viewerLastReadAt = getLastReadAtForChatViewer(chat.participants, viewer);

    const { author, createdAt, content } = chat.lastEvent;
    const { id, displayName } = recipient;

    const profileUrl = getProfileURL(id);
    const avatarUrl = getAvatarURL(id);
    const isUnread = getUnreadState(createdAt, viewerLastReadAt);

    variations.push(isUnread && !isActive ? 'unread' : 'read');

    return (
        <a
            href={`/messages/${recipient.id}`}
            className={getComponentClasses('onsite-messages__list-item', variations)}
            data-qm-block
        >
            <div className="onsite-messages__avatar">
                <Avatar
                    variations={avatarVariations}
                    isLinked={false}
                    isOnline={isActive}
                    user={{ profileUrl, avatarUrl }}
                />
            </div>
            <div className="onsite-messages__body">
                <div className="onsite-messages__meta">
                    <span className="onsite-messages__meta__username">{displayName}</span>
                    <span className="onsite-messages__meta__timestamp">
                        <Timestamp timestamp={createdAt} abbreviate />
                    </span>
                </div>

                <div className="onsite-messages__content">
                    {viewer && viewer.id === author!.id ? 'You: ' : null}
                    {content}
                </div>
            </div>
        </a>
    );
};
export default OnsiteMessagesListItem;
